module.exports = __webpack_public_path__ + "static/media/containerIcon.0af2badb.svg";